(function () {
  'use strict';
  if (window.__wpcFitmentVerificationV2) {
    window.__wpcFitmentVerificationV2.scan();
    return;
  }

  var COOLDOWN_KEY = 'wpc_fitment_cooldown_until_v1'; // only an expiry timestamp, never PII
  var ACTIVE_CONTACT_KEY = 'wpc_contact_active_form_v1'; // isolates the two contact forms
  var PENDING_PREFIX = 'wpc_fitment_pending_v1_'; // session-only timestamp, never PII
  var DRAFT_PREFIX = 'wpc_fitment_draft_v1_'; // temporary in-tab draft, never localStorage
  var COOLDOWN_MS = 5 * 60 * 1000;
  var PENDING_MS = 15 * 60 * 1000;
  var timers = new WeakMap();
  var portaledOverlays = new WeakMap();
  var owners = new WeakMap();
  var previousOverflow = null;
  var memoryCooldown = 0;
  var localStore = null, sessionStore = null;
  try { localStore = window.localStorage; } catch (err) { /* Storage may be unavailable. */ }
  try { sessionStore = window.sessionStorage; } catch (err) { /* Storage may be unavailable. */ }

  function storeGet(storage, key) { try { return storage.getItem(key); } catch (err) { return null; } }
  function storeSet(storage, key, value) { try { storage.setItem(key, String(value)); } catch (err) { /* Storage may be disabled. */ } }
  function storeRemove(storage, key) { try { storage.removeItem(key); } catch (err) { /* Storage may be disabled. */ } }
  function cooldownUntil() { return Math.max(memoryCooldown, Number(storeGet(localStore, COOLDOWN_KEY)) || 0); }
  function remaining() { return Math.max(0, cooldownUntil() - Date.now()); }
  function pendingKey(root) { return PENDING_PREFIX + root.dataset.productId; }
  function draftKey(root) { return DRAFT_PREFIX + root.dataset.productId; }
  function clearDraft(root) { storeRemove(sessionStore, draftKey(root)); }
  function saveDraft(root) {
    // Only after explicit Send Request. Session-only and removed upon a Shopify response.
    // VIN, email and phone are NEVER placed in localStorage or in the URL.
    var saved = { savedAt: Date.now(),
      year: field(root, 'year').value,
      make: field(root, 'make').value,
      model: field(root, 'model').value,
      vin: field(root, 'vin').value,
      email: field(root, 'email').value,
      phone: field(root, 'phone').value,
      agreement: field(root, 'agreement').checked
    };
    storeSet(sessionStore, draftKey(root), JSON.stringify(saved));
  }
  function restoreDraft(root) {
    var raw = storeGet(sessionStore, draftKey(root));
    clearDraft(root);
    if (!raw) return;
    try {
      var saved = JSON.parse(raw);
      if (!saved || !(Date.now() - saved.savedAt >= 0 && Date.now() - saved.savedAt < PENDING_MS)) return;
      ['year', 'make', 'model', 'vin', 'email', 'phone'].forEach(function (name) {
        if (typeof saved[name] === 'string') field(root, name).value = saved[name];
      });
      field(root, 'agreement').checked = !!saved.agreement;
    } catch (err) { /* Ignore incomplete drafts. */ }
  }
  function element(root, selector) {
    var found = root.querySelector(selector);
    if (found) return found;
    var overlay = portaledOverlays.get(root);
    if (!overlay) return null;
    return overlay.matches(selector) ? overlay : overlay.querySelector(selector);
  }
  function ownerFor(node) {
    var root = node.closest('[data-wpc-fitment]');
    if (root) return root;
    var overlay = node.closest('[data-wpc-fitment-overlay]');
    return overlay ? owners.get(overlay) : null;
  }
  function portal(root) {
    var overlay = element(root, '[data-wpc-fitment-overlay]');
    if (!overlay) return;
    if (overlay.parentNode !== document.body) {
      portaledOverlays.set(root, overlay);
      owners.set(overlay, root);
      document.body.appendChild(overlay);
    }
  }
  function tidyUrl() {
    // Cosmetic history cleanup only, AFTER Shopify confirms contact success.
    // Never changes form submission, CAPTCHA, or the requested product page.
    try {
      var url = new URL(window.location.href);
      var modified = false;
      if (url.searchParams.get('contact_posted') === 'true') {
        url.searchParams.delete('contact_posted');
        modified = true;
      }
      if (/^#(?:wpc-fit-|FitmentVerifyForm|contact_form)/i.test(url.hash)) {
        url.hash = '';
        modified = true;
      }
      if (modified) window.history.replaceState(window.history.state, '', url.href);
    } catch (err) { /* History might be restricted; normal Shopify URL remains. */ }
  }
  function field(root, name) { return element(root, '[data-wpc-field="' + name + '"]'); }
  function isVisible(root) { return !element(root, '[data-wpc-fitment-overlay]').hidden; }

  function setError(root, name, message) {
    var input = field(root, name);
    var error = element(root, '[data-wpc-error="' + name + '"]');
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
    error.textContent = message || '';
    error.hidden = !message;
  }

  // Reject common syntactically invalid addresses before Shopify receives the form.
  // Shopify remains the authority on whether an address is accepted.
  function validEmail(input) {
    var value = input.value.trim();
    if (!value || value.length > 254 || !input.validity.valid) return false;
    var at = value.lastIndexOf('@');
    if (at <= 0 || at !== value.indexOf('@')) return false;
    var local = value.slice(0, at);
    var domain = value.slice(at + 1);
    if (local.length > 64 || local.charAt(0) === '.' || local.endsWith('.') || local.includes('..')) return false;
    var labels = domain.split('.');
    if (labels.length < 2 || labels[labels.length - 1].length < 2 || domain.length > 253) return false;
    return labels.every(function (label) { return /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/.test(label); });
  }

  function clearFooterFormResponse() {
    // Shopify may incorrectly share contact-form errors with its footer 'customer'
    // newsletter form. Suppress that unrelated feedback ONLY on a fitment response.
    function clear() {
      document.querySelectorAll('form.custom-footer__newsletter-form').forEach(function (newsletter) {
        newsletter.querySelectorAll('.custom-footer__newsletter-message').forEach(function (message) {
          message.hidden = true;
          message.style.display = 'none';
        });
        newsletter.querySelectorAll('input[aria-invalid="true"]').forEach(function (input) {
          input.removeAttribute('aria-invalid');
          if (input.getAttribute('aria-describedby') === 'ContactFooter-error') input.removeAttribute('aria-describedby');
          input.removeAttribute('autofocus');
        });
      });
    }
    clear();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clear, { once: true });
  }

  function validate(root, step, moveFocus) {
    var firstInvalid = null;
    function check(name, good, message) {
      setError(root, name, good ? '' : message);
      if (!good && !firstInvalid) firstInvalid = field(root, name);
    }
    if (step === 1) {
      var year = field(root, 'year').value.trim();
      var numericYear = Number(year);
      check('year', /^\d{4}$/.test(year) && numericYear >= 1950 && numericYear <= new Date().getFullYear() + 2,
        'Enter a four-digit year between 1950 and ' + (new Date().getFullYear() + 2) + '.');
    }
    if (step === 2) {
      check('make', !!field(root, 'make').value.trim(), 'Enter your vehicle make.');
      check('model', !!field(root, 'model').value.trim(), 'Enter your vehicle model.');
    }
    if (step === 3) {
      var vinInput = field(root, 'vin');
      vinInput.value = vinInput.value.replace(/\s+/g, '').toUpperCase();
      check('vin', /^[A-HJ-NPR-Z0-9]{17}$/.test(vinInput.value),
        'Enter exactly 17 VIN characters using A–Z and 0–9, excluding I, O and Q.');
    }
    if (step === 4) {
      var email = field(root, 'email');
      check('email', validEmail(email), 'Enter a valid email address.');
      check('agreement', field(root, 'agreement').checked, 'Please agree before sending your request.');
    }
    if (firstInvalid && moveFocus !== false) firstInvalid.focus();
    return !firstInvalid;
  }

  function showStep(root, value, focus) {
    var step = Math.min(4, Math.max(1, value));
    root.dataset.wpcStep = String(step);
    element(root, '[data-wpc-fitment-dialog]').querySelectorAll('[data-wpc-fitment-step]').forEach(function (node) {
      node.hidden = Number(node.dataset.wpcFitmentStep) !== step;
    });
    element(root, '[data-wpc-fitment-count]').textContent = 'STEP ' + String(step).padStart(2, '0') + ' / 04';
    element(root, '[data-wpc-fitment-stage]').textContent = ['VEHICLE YEAR', 'MAKE & MODEL', 'VIN', 'CONTACT DETAILS'][step - 1];
    element(root, '[data-wpc-fitment-progress]').value = step;
    element(root, '[data-wpc-fitment-back]').hidden = step === 1;
    element(root, '[data-wpc-fitment-next]').hidden = step === 4;
    element(root, '[data-wpc-fitment-send]').hidden = step !== 4;
    if (focus) {
      var target = element(root, '[data-wpc-fitment-step="' + step + '"] input');
      if (target) target.focus();
    }
  }

  function showView(root, view) {
    element(root, '[data-wpc-fitment-form-view]').hidden = view !== 'form';
    element(root, '[data-wpc-fitment-success-view]').hidden = view !== 'success';
    element(root, '[data-wpc-fitment-cooldown-view]').hidden = view !== 'cooldown';
    root.dataset.wpcView = view;
    var dialog = element(root, '[data-wpc-fitment-dialog]');
    if (view === 'form') {
      dialog.setAttribute('aria-labelledby', element(root, '.wpc-fitment__title').id);
      dialog.setAttribute('aria-describedby', element(root, '.wpc-fitment__subtitle').id);
    } else {
      var panel = element(root, '[data-wpc-fitment-' + view + '-view]');
      dialog.setAttribute('aria-labelledby', panel.querySelector('.wpc-fitment__title').id);
      dialog.setAttribute('aria-describedby', panel.querySelector('.wpc-fitment__subtitle').id);
    }
    if (view === 'cooldown') refreshTime(root);
  }

  function refreshTime(root) {
    var ms = remaining();
    var seconds = Math.ceil(ms / 1000);
    var minutes = Math.floor(seconds / 60);
    element(root, '[data-wpc-fitment-remaining]').textContent = minutes + ':' + String(seconds % 60).padStart(2, '0');
    if (ms <= 0 && isVisible(root) && root.dataset.wpcView === 'cooldown') {
      showStep(root, 1, false);
      showView(root, 'form');
      field(root, 'year').focus();
    }
  }

  function clearTimers(root) {
    var t = timers.get(root);
    if (t) {
      if (t.close) window.clearTimeout(t.close);
      if (t.interval) window.clearInterval(t.interval);
    }
    timers.delete(root);
  }

  function close(root) {
    clearTimers(root);
    element(root, '[data-wpc-fitment-overlay]').hidden = true;
    root.dataset.wpcOpen = 'false';
    if (previousOverflow !== null) {
      document.body.style.overflow = previousOverflow;
      previousOverflow = null;
    }
    var trigger = element(root, '[data-wpc-fitment-open]');
    if (trigger && trigger.isConnected) trigger.focus();
  }

  function open(root, view) {
    document.querySelectorAll('[data-wpc-fitment][data-wpc-open="true"]').forEach(function (other) {
      if (other !== root) close(other);
    });
    clearTimers(root);
    if (previousOverflow === null) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    portal(root);
    var overlay = element(root, '[data-wpc-fitment-overlay]');
    overlay.hidden = false;
    root.dataset.wpcOpen = 'true';
    if (view !== 'success') view = remaining() > 0 ? 'cooldown' : 'form';
    showView(root, view);
    if (view === 'cooldown') {
      timers.set(root, { interval: window.setInterval(function () { refreshTime(root); }, 1000) });
    } else if (view === 'success') {
      timers.set(root, { close: window.setTimeout(function () { if (isVisible(root) && root.dataset.wpcView === 'success') close(root); }, 5000) });
    }
    var focusTarget = view === 'form' ? element(root, '[data-wpc-fitment-step="' + (root.dataset.wpcStep || '1') + '"] input') : element(root, '[data-wpc-fitment-' + view + '-view]');
    if (focusTarget) focusTarget.focus();
    else element(root, '[data-wpc-fitment-dialog]').focus();
  }

  function currentVariant(root) {
    var productSection = root.closest('[data-wp-amazon-product]');
    var select = productSection && productSection.querySelector('[data-wp-variant-select]');
    var selected = select && select.selectedOptions[0];
    var hidden = productSection && productSection.querySelector('[data-wp-variant-input]');
    return {
      id: selected ? selected.value : (hidden ? hidden.value : root.dataset.initialVariant),
      sku: selected ? (selected.dataset.sku || '') : root.dataset.initialSku,
      title: selected ? selected.textContent.trim() : root.dataset.initialVariantTitle
    };
  }

  function fillContact(root) {
    var variant = currentVariant(root);
    var rawUrl = root.dataset.productUrl;
    var url = new URL(rawUrl, window.location.href);
    if (variant.id) url.searchParams.set('variant', variant.id);
    var values = {
      year: field(root, 'year').value.trim(),
      make: field(root, 'make').value.trim(),
      model: field(root, 'model').value.trim(),
      vin: field(root, 'vin').value.replace(/\s+/g, '').toUpperCase(),
      email: field(root, 'email').value.trim(),
      phone: field(root, 'phone').value.trim()
    };
    element(root, '[data-wpc-contact-body]').value = [
      'Request Tag: WPCFITMENTREQUEST',
      'Product URL: ' + url.href,
      'Vehicle Year: ' + values.year,
      'Vehicle Make: ' + values.make,
      'Vehicle Model: ' + values.model,
      'VIN: ' + values.vin,
      'Contact Agreement: Yes'
    ].join('\n');
  }

  function scan() {
    document.querySelectorAll('[data-wpc-fitment]:not([data-wpc-initialized])').forEach(function (root) {
      root.dataset.wpcInitialized = 'true';
      root.dataset.wpcStep = '1';
      var submittedAt = Number(storeGet(sessionStore, pendingKey(root))) || 0;
      var freshPending = submittedAt > 0 && (Date.now() - submittedAt) >= 0 && (Date.now() - submittedAt) < PENDING_MS;
      var activeForm = storeGet(sessionStore, ACTIVE_CONTACT_KEY);
      // Legacy pending entries remain valid if no other form has taken ownership.
      var ownedResponse = !activeForm || activeForm === 'fitment:' + root.dataset.productId;
      var success = ownedResponse && !!element(root, '[data-wpc-fitment-server-success]');
      var serverError = element(root, '[data-wpc-fitment-server-error]');
      if (success && freshPending) {
        storeRemove(sessionStore, ACTIVE_CONTACT_KEY);
        storeRemove(sessionStore, pendingKey(root));
        clearDraft(root);
        clearFooterFormResponse();
        memoryCooldown = Date.now() + COOLDOWN_MS;
        storeSet(localStore, COOLDOWN_KEY, memoryCooldown);
        tidyUrl();
        open(root, 'success');
      } else if (freshPending && ownedResponse) {
        storeRemove(sessionStore, ACTIVE_CONTACT_KEY);
        // A normal Shopify POST reload may return an error, or no usable result
        // after an interrupted CAPTCHA. In either case, don't leave the customer
        // looking at an unrelated newsletter error in the page footer.
        storeRemove(sessionStore, pendingKey(root));
        restoreDraft(root);
        clearFooterFormResponse();
        if (serverError) serverError.hidden = false;
        else element(root, '[data-wpc-fitment-fallback-error]').hidden = false;
        showStep(root, 4, false);
        open(root, 'form');
        if (serverError && /email/i.test(serverError.textContent)) setError(root, 'email', 'Check your email address and try again.');
      } else if (!freshPending) {
        // Discard abandoned session-only personal data after the pending window.
        clearDraft(root);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var action = event.target.closest('[data-wpc-fitment-open], [data-wpc-fitment-close], [data-wpc-fitment-next], [data-wpc-fitment-back]');
    if (action) {
      var root = ownerFor(action);
      if (!root) return;
      if (action.matches('[data-wpc-fitment-open]')) { open(root); return; }
      if (action.matches('[data-wpc-fitment-close]')) { close(root); return; }
      var step = Number(root.dataset.wpcStep) || 1;
      if (action.matches('[data-wpc-fitment-next]') && step < 4 && validate(root, step)) showStep(root, step + 1, true);
      if (action.matches('[data-wpc-fitment-back]') && step > 1) showStep(root, step - 1, true);
      return;
    }
    var backdrop = event.target.closest('[data-wpc-fitment-overlay]');
    if (backdrop && event.target === backdrop) {
      var root = owners.get(backdrop) || backdrop.closest('[data-wpc-fitment]');
      if (root) close(root);
    }
  });

  // Prevent spaces during VIN typing. Input sanitizing below also covers mobile keyboards,
  // autofill and other input methods that do not reliably fire beforeinput.
  document.addEventListener('beforeinput', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-wpc-field="vin"]') || !ownerFor(input)) return;
    if (event.inputType === 'insertText' && event.data && /\s/.test(event.data)) event.preventDefault();
  });

  // Strip spaces BEFORE a pasted VIN reaches maxlength=17, so pasted VINs with
  // separators won't lose the last characters before the input handler runs.
  document.addEventListener('paste', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-wpc-field="vin"]') || !ownerFor(input)) return;
    var pasted = event.clipboardData && event.clipboardData.getData('text');
    if (pasted == null) return;
    event.preventDefault();
    var start = input.selectionStart == null ? input.value.length : input.selectionStart;
    var end = input.selectionEnd == null ? start : input.selectionEnd;
    var room = Math.max(0, 17 - (input.value.length - (end - start)));
    input.setRangeText(pasted.replace(/\s+/g, '').toUpperCase().slice(0, room), start, end, 'end');
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-wpc-field]');
    if (!input) return;
    var root = ownerFor(input);
    if (!root) return;
    if (input.dataset.wpcField === 'vin') {
      var original = input.value;
      var normalized = original.replace(/\s+/g, '').toUpperCase();
      if (original !== normalized) {
        var start = input.selectionStart, end = input.selectionEnd;
        input.value = normalized;
        // Keep the caret in place when editing inside an existing VIN.
        if (start !== null && end !== null) {
          input.setSelectionRange(
            original.slice(0, start).replace(/\s+/g, '').length,
            original.slice(0, end).replace(/\s+/g, '').length
          );
        }
      }
    }
    if (element(root, '[data-wpc-error="' + input.dataset.wpcField + '"]')) setError(root, input.dataset.wpcField, '');
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-wpc-field="agreement"]')) {
      var root = ownerFor(event.target);
      if (root) setError(root, 'agreement', '');
    }
  });

  document.addEventListener('keydown', function (event) {
    var current = document.querySelector('[data-wpc-fitment][data-wpc-open="true"]');
    if (!current) return;
    if (event.key === 'Escape') { event.preventDefault(); close(current); return; }
    var dialog = element(current, '[data-wpc-fitment-dialog]');
    if (event.key === 'Tab' && dialog.contains(event.target)) {
      var elements = Array.from(dialog.querySelectorAll('button, input:not([type="hidden"]), a[href], select, textarea:not([hidden])'))
        .filter(function (node) { return !node.disabled && !node.closest('[hidden]') && node.getClientRects().length > 0; });
      if (!elements.length) { event.preventDefault(); dialog.focus(); return; }
      var first = elements[0], last = elements[elements.length - 1];
      if (!elements.includes(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      return;
    }
    if (event.key !== 'Enter') return;
    var target = event.target;
    if (!(target instanceof HTMLInputElement) || ownerFor(target) !== current) return;
    event.preventDefault(); // No implicit form submit while navigating steps.
    var name = target.dataset.wpcField;
    var step = Number(current.dataset.wpcStep) || 1;
    if (name === 'make') { field(current, 'model').focus(); return; }
    if ((name === 'year' || name === 'model' || name === 'vin') && step < 4) {
      if (validate(current, step)) showStep(current, step + 1, true);
    } else if (name === 'email') {
      field(current, 'phone').focus();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form.wpc-fitment__form')) return;
    var root = ownerFor(form);
    if (!root) return;
    if (remaining() > 0) { event.preventDefault(); event.stopImmediatePropagation(); open(root); return; }
    var step = Number(root.dataset.wpcStep) || 1;
    if (step !== 4) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (validate(root, step)) showStep(root, Math.min(4, step + 1), true);
      return;
    }
    var firstBadStep = 0;
    [1, 2, 3, 4].forEach(function (i) {
      if (!validate(root, i, false) && !firstBadStep) firstBadStep = i;
    });
    if (firstBadStep) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showStep(root, firstBadStep, false);
      var invalid = element(root, '[data-wpc-fitment-step="' + firstBadStep + '"] [aria-invalid="true"]');
      if (invalid) invalid.focus();
      return;
    }
    fillContact(root);
    saveDraft(root);
    storeSet(sessionStore, ACTIVE_CONTACT_KEY, 'fitment:' + root.dataset.productId);
    storeSet(sessionStore, pendingKey(root), Date.now());
    // Do not preventDefault, fetch, call form.submit(), or interfere with Shopify hCaptcha.
  }, true);

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-wpc-fitment]').forEach(function (root) {
      if (root.dataset.wpcOpen === 'true') close(root);
      var overlay = portaledOverlays.get(root);
      if (overlay) {
        overlay.remove();
        owners.delete(overlay);
        portaledOverlays.delete(root);
      }
    });
  });
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  window.__wpcFitmentVerificationV2 = { scan: scan };
})();